var map = {
	"./affaere1/envelope-fixed-green.svg": 88850,
	"./affaerentreff/envelope-fixed-green.svg": 57156,
	"./casualxdates/envelope-fixed-green.svg": 71465,
	"./envelope-fixed-green.svg": 87304,
	"./ficktreffpunkt24/envelope-fixed-green.svg": 29375,
	"./fremdgehboerse/envelope-fixed-green.svg": 7,
	"./illicitoasis/envelope-fixed-green.svg": 7954,
	"./seitensprungtreff69/envelope-fixed-green.svg": 13226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79612;